import { defineChain } from 'viem';
export const abcWagmi = /*#__PURE__*/ defineChain({
  id: 20250903,
  name: 'ABC',
  nativeCurrency: { name: 'MockF', symbol: 'MOCKF', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://rpc.synfutures-abc-testnet.raas.gelato.cloud/2ff2e1ea1a68484785779c5a072bed95'],
    },
  },
  blockExplorers: {
    default: {
      name: 'ABC Test Explorer',
      url: 'https://synfutures-abc-testnet.cloud.blockscout.com',
      apiUrl: 'https://synfutures-abc-testnet.cloud.blockscout.com/api',
    },
  },
  contracts: {
    multicall3: {
      address: '0x5AC0088a2614EFbAF2f4B01130e6F8BbA66f13fD',
      blockCreated: 196,
    },
  },
});
